import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BasePage } from "src/pages/base.page";
import { MoneyHelper } from "projects/core/src/lib/core/MoneyHelper";
import FormatHelper from "projects/core/src/lib/core/FormatHelper";

@Component({
    selector: 'CarteiraRecomendadaSimuladorPage',
    templateUrl: 'CarteiraRecomendadaSimuladorPage.html',
    styleUrls: ['CarteiraRecomendadaSimuladorPage.scss'],
})
export class CarteiraRecomendadaSimuladorPage extends BasePage {
    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        super(router)
    }

    simularOk = false
    ativosParam = []
    mercado
    ativos = []
    valorSimular = "0,00"
    valorTotal = ""
    textInformacao = ["Olá, Investidor", "Importante observar a legenda acima para evitar comprar determinado ativo que está com o preço acima do preço máximo recomendado pelo nosso especialista da carteira.  Observar está condição para evitar entrada em ativo nesta situação (sinalizamos ao lado do ativo com uma barra vertical em cor vermelha). A carteira tem uma dinâmica de entradas e saídas de ativos ao longo do tempo, considerando análise do especialista que busca maximizar rentabilidade e proteção de capital pela gestão de risco. Bons investimentos!"]

    ngOnInit() {
        const _self = this
        this.activatedRoute.queryParams.subscribe(params => {
            const data = JSON.parse(params.data)
            _self.ativosParam = data.ativos
            _self.mercado = data.mercado
        })
    }

    getMoedaPorMercado() {
        return this.mercado == "Criptomoedas" ? "$" : "R$"
    }

    calcular() {
        if (!this.valorSimular || this.valorSimular == "" || MoneyHelper.moneyStringToFloat(this.valorSimular) < 0) return
        this.simularOk = false
        this.ativos = []
        let valorTotalAux = 0
        const ativosAux = []
        this.ativosParam.forEach((ativo) => {
            var quantidade = (MoneyHelper.moneyStringToFloat(this.valorSimular) * (ativo.peso / 100)) / ativo.precoAtual
            quantidade = parseFloat(quantidade.toPrecision(4))
            let quantidadeFinal = quantidade.toString().replace(".", ",")
            const codigoAtivo = ativo.codigo.substring(ativo.codigo.length - 3, ativo.codigo.lentgh) == "USD" ? ativo.codigo.replace("USD", "") : ativo.codigo
            ativosAux.push({
                codigo: codigoAtivo,
                quantidade: quantidadeFinal,
                preco: ativo.precoAtual_str,
                alocacao_str: ativo.peso_str,
                alocacao: ativo.peso,
                total: FormatHelper.formatCotacao(ativo.precoAtual * quantidade, null, null, 2, 2),
                recomendaCompra: ativo.precoAtual <= ativo.precoMaximo,
                precoMaximo_str: ativo.precoMaximo_str
            })
            valorTotalAux += ativo.precoAtual * quantidade
        })
        ativosAux.sort((next, current) => {
            if (current.alocacao > next.alocacao) return 1;
            if (next.alocacao > current.alocacao) return -1;
            return 0;
        })
        this.valorTotal = FormatHelper.formatCotacao(valorTotalAux, null, null, 2, 2)
        this.ativos = ativosAux
        this.simularOk = true
    }
}